import React, { FC } from 'react';
import { IconProps } from 'types';

export const GuyanaFlag: FC<IconProps> = ({ width, height }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 60">
      <title>Flag of Guyana</title>
      <defs>
        <clipPath id="w">
          <path d="m0 0 100 30L0 60z" />
        </clipPath>
        <clipPath id="b">
          <path d="m0 0 50 30L0 60z" />
        </clipPath>
      </defs>
      <path fill="#2A936A" d="m0 0h100v60H0z" />
      <path clipPath="url(#w)" fill="#FFC20E" stroke="#fff" stroke-width="4" d="m0 0 100 30L0 60" />
      <path clipPath="url(#b)" fill="#BE1E2D" stroke="#000" strokeWidth="4" d="m0 0 50 30L0 60" />
    </svg>
  );
};
